import remarkParse from "remark-parse";
import remarkBreaks from "remark-breaks";
import { unified } from "unified";
import { Content } from "mdast";
import { ReactElement, ReactNode } from "react";

const parser = unified().use(remarkParse).use(remarkBreaks);

function render(c: Content, key = 0): ReactNode {
  const children = "children" in c ? c.children.map(render) : null;
  switch (c.type) {
    case "paragraph":
      return <p key={key}>{children}</p>;
    case "list":
      return c.ordered ? <ol key={key}>{children}</ol> : <ul key={key}>{children}</ul>;
    case "listItem":
      return <li key={key}>{children}</li>;
    case "break":
      return <br key={key} />;
    case "emphasis":
      return <em key={key}>{children}</em>;
    case "strong":
      return <strong key={key}>{children}</strong>;
    case "text":
      return c.value;
    case "heading":
      return children;
    case "html":
      return c.value;
    case "link":
      return c.url?.startsWith("/") ? (
        <a key={key} href={c.url}>
          {children}
        </a>
      ) : (
        <a key={key} href={c.url} target={"_blank"}>
          {children}
        </a>
      );
    default:
      return null;
  }
}

export function markdownToHtml(markdown: string): ReactElement {
  const node = parser.runSync(parser.parse(markdown));
  return <>{node.children.map(render)}</>;
}
